<div
  fxLayout="column"
  class="dx-card card-container card-paddings responsive-paddings progress-style"
  fxLayoutGap="10px"
>
  <div class="card-header">
    <h3 class="card-title">
      {{ translator("Ubt-Measure-Detail-EffortBenefitAssessmentTitle") }}
    </h3>
  </div>

  <div class="card-content-evaluation">
    <div class="evaluation-item">
      <h4 class="evaluation-item-title">
        {{ translator("Ubt-Measure-Detail-EffortBenefitAssessment-effort") }}
      </h4>
      <ubt-geods-rating
        [disabled]="true"
        [icon]="iconSvg"
        [fillColor]="fillColor"
        [emptyColor]="emptyColor"
        [starCount]="ratingCount"
        [rating]="rating.Effort"
        (onRatingUpdated)="onUpdateEffortRate($event)"
      ></ubt-geods-rating>
      <p class="evaluation-item-hint">
        {{ translator("Ubt-Measure-Detail-EffortBenefitAssessmentEffortHint") }}
      </p>
    </div>

    <div class="evaluation-item">
      <h4 class="evaluation-item-title">
        {{ translator("Ubt-Measure-Detail-EffortBenefitAssessmentBenefit") }}
      </h4>
      <ubt-geods-rating
        [disabled]="true"
        [icon]="euroSvg"
        [fillColor]="fillColor"
        [emptyColor]="emptyColor"
        [starCount]="ratingCount"
        [rating]="rating.Benefit"
        (onRatingUpdated)="onUpdateBenefitRate($event)"
      ></ubt-geods-rating>
      <p class="evaluation-item-hint">
        {{
          translator("Ubt-Measure-Detail-EffortBenefitAssessmentBenefitHint")
        }}
      </p>
    </div>

    <div class="evaluation-item">
      <div class="title-container">
        <h4 class="evaluation-item-title">
          {{
            translator(
              "Ubt-Measure-Detail-EffortBenefitAssessmentMeasureEffect"
            )
          }}
        </h4>
        <abc-button
          icon="info"
          class="hint-btn"
          [hint]="
            translator(
              'Ubt-Measure-Detail-EffortBenefitAssessmentMeasureEffectHint'
            )
          "
        ></abc-button>
      </div>
      <p class="evaluation-item-value">
        {{ rating.Impact | currency: "EUR" : "symbol" : "1.0-0" }}
      </p>
    </div>

    <div class="evaluation-item">
      <h4 class="evaluation-item-title">
        {{
          translator("Ubt-Measure-Detail-EffortBenefitAssessmentMeasureCosts")
        }}
      </h4>
      <p class="evaluation-item-value">
        {{ rating.Cost | currency: "EUR" : "symbol" : "1.0-0" }}
      </p>
    </div>

    <hr class="split-line" />

    <div class="evaluation-item">
      <h4 class="evaluation-item-title">
        {{
          translator(
            "Ubt-Measure-Detail-EffortBenefitAssessmentMeasureTotalScore"
          )
        }}
      </h4>
      <abc-progress-bar
        #progressBar
        id="progress-bar-status"
        width="100%"
        [elementAttr]="{ 'aria-label': 'Progress Bar' }"
        [min]="0"
        [max]="maxScore"
        [statusFormat]="formatStaus"
        [value]="rating.TotalScore"
      ></abc-progress-bar>
    </div>
    <hr class="split-line" />
  </div>

  <div class="card-footer">
    <div class="recent-actvities-section">
      <abc-button
        icon="clock"
        (click)="showRatingHistory()"
        class="action-button"
        [hint]="
          translator(
            'Ubt-Measure-Detail-EffortBenefitAssessmentSeeHistoryOfChanges'
          )
        "
      ></abc-button>
      @if (rating?.createdAt) {
        <p class="last-change-made">
          {{
            translator("Ubt-Measure-Detail-EffortBenefitAssessmentLastChangeBy")
          }}
          <span>{{ rating?.personFullName }}</span>
          {{
            translator("Ubt-Measure-Detail-EffortBenefitAssessmentLastChangeOn")
          }}
          <span>{{ rating?.createdAt | date: "dd.MM.yyyy HH:mm" }}</span>
        </p>
      } @else {
        <p class="last-change-made">
          {{
            translator("Ubt-Measure-Detail-EffortBenefitAssessmentNoLastChange")
          }}
        </p>
      }

      <abc-button
        icon="edit"
        (click)="showRatingPopup()"
        class="action-button"
        [hint]="translator('Ubt-Measure-Detail-EffortBenefitAssessmentEdit')"
        [disabled]="!checkPermission()"
      ></abc-button>
    </div>
  </div>
</div>

<!-- Rating Popup -->
<abc-popup
  #ratingPopup
  [height]="'70%'"
  [maxHeight]="'700px'"
  [minHeight]="'400px'"
  [width]="'80%'"
  [maxWidth]="'500px'"
  [minWidth]="'300px'"
  [dragEnabled]="false"
  [showCloseButton]="false"
  [showTitle]="false"
  class="rating-popup"
  [wrapperAttr]="{ class: 'rating-popup-wrapper' }"
>
  <div
    fxLayout="column"
    class="dx-card card-container progress-style"
    fxLayoutGap="10px"
  >
    <div class="card-header">
      <h3 class="card-title">
        {{ translator("Ubt-Measure-Detail-EffortBenefitAssessmentTitle") }}
      </h3>
      <abc-button
        class="close-btn"
        (click)="cancelEdit()"
        icon="close"
      ></abc-button>
    </div>

    <div class="card-content-evaluation">
      <div class="evaluation-item">
        <h4 class="evaluation-item-title">
          {{ translator("Ubt-Measure-Detail-EffortBenefitAssessment-effort") }}
        </h4>
        <ubt-geods-rating
          [icon]="iconSvg"
          [fillColor]="fillColor"
          [emptyColor]="emptyColor"
          [starCount]="ratingCount"
          [rating]="rating.Effort"
          (onRatingUpdated)="onUpdateEffortRate($event)"
        ></ubt-geods-rating>
        <p class="evaluation-item-hint">
          {{
            translator("Ubt-Measure-Detail-EffortBenefitAssessmentEffortHint")
          }}
        </p>
      </div>

      <div class="evaluation-item">
        <h4 class="evaluation-item-title">
          {{ translator("Ubt-Measure-Detail-EffortBenefitAssessmentBenefit") }}
        </h4>
        <ubt-geods-rating
          [icon]="euroSvg"
          [fillColor]="fillColor"
          [emptyColor]="emptyColor"
          [starCount]="ratingCount"
          [rating]="rating.Benefit"
          (onRatingUpdated)="onUpdateBenefitRate($event)"
        ></ubt-geods-rating>
        <p class="evaluation-item-hint">
          {{
            translator("Ubt-Measure-Detail-EffortBenefitAssessmentBenefitHint")
          }}
        </p>
      </div>

      <div class="evaluation-item">
        <div class="title-container">
          <h4 class="evaluation-item-title">
            {{
              translator(
                "Ubt-Measure-Detail-EffortBenefitAssessmentMeasureEffect"
              )
            }}
          </h4>
          <abc-button
            icon="info"
            class="hint-btn"
            [hint]="
              translator(
                'Ubt-Measure-Detail-EffortBenefitAssessmentMeasureEffectHint'
              )
            "
          ></abc-button>
        </div>
        <abc-number-box
          [(value)]="rating.Impact"
          (onValueChanged)="onValueChange()"
          [format]="{ type: 'currency', currency: 'EUR' }"
          class="currency-input"
        ></abc-number-box>
      </div>

      <div class="evaluation-item">
        <h4 class="evaluation-item-title">
          {{
            translator("Ubt-Measure-Detail-EffortBenefitAssessmentMeasureCosts")
          }}
        </h4>
        <abc-number-box
          [(value)]="rating.Cost"
          (onValueChanged)="onValueChange()"
          [format]="{ type: 'currency', currency: 'EUR' }"
          class="currency-input"
        ></abc-number-box>
      </div>

      <div class="evaluation-item">
        <h4 class="evaluation-item-title">
          {{
            translator(
              "Ubt-Measure-Detail-EffortBenefitAssessmentMeasureComment"
            )
          }}
        </h4>
        <abc-text-area
          [autoResizeEnabled]="true"
          width="100%"
          height="75px"
          [(value)]="rating.comment"
          (onValueChanged)="onValueChange()"
        ></abc-text-area>
      </div>

      <hr class="split-line" />

      <div class="evaluation-item">
        <h4 class="evaluation-item-title">
          {{
            translator(
              "Ubt-Measure-Detail-EffortBenefitAssessmentMeasureTotalScore"
            )
          }}
        </h4>
        <abc-progress-bar
          #progressBar
          id="progress-bar-status"
          width="100%"
          [elementAttr]="{ 'aria-label': 'Progress Bar' }"
          [class.complete]="progressBar.value == maxScore"
          [min]="0"
          [max]="maxScore"
          [statusFormat]="formatStaus"
          [value]="rating.TotalScore"
        ></abc-progress-bar>
      </div>
    </div>

    <div class="card-footer">
      <div class="btn-container">
        <abc-button
          class="cancel-btn"
          [text]="translator('Ubt-CreateMeasure-Cancel')"
          (click)="cancelEdit()"
        ></abc-button>
        <abc-button
          class="submit-btn"
          [text]="translator('Ubt-MeasureDetail-Save')"
          (click)="submit()"
          [disabled]="!canEdit"
        ></abc-button>
      </div>
    </div>
  </div>
</abc-popup>

<!-- Rating History Popup -->
<abc-popup
  #ratingHistoryPopup
  [height]="'70%'"
  [maxHeight]="'700px'"
  [minHeight]="'400px'"
  [width]="'80%'"
  [maxWidth]="'500px'"
  [minWidth]="'300px'"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  [showCloseButton]="false"
  [showTitle]="false"
  class="rating-popup"
  [wrapperAttr]="{ class: 'rating-popup-wrapper' }"
>
  <div
    fxLayout="column"
    class="dx-card card-container progress-style"
    fxLayoutGap="10px"
  >
    <div class="card-header">
      <h3 class="card-title">
        {{
          translator(
            "Ubt-Measure-Detail-EffortBenefitAssessmentHistoryOfChanges"
          )
        }}
      </h3>
      <abc-button
        class="close-btn"
        (click)="hideRatingHistory()"
        icon="close"
      ></abc-button>
    </div>

    <div class="card-content-evaluation">
      <dx-scroll-view #scrollView id="scrollview" height="580px">
        <div class="history-container">
          @for (item of ratingHistory; track $index) {
            <div #cardHistory class="history-item">
              <!-- Header: Who & When -->
              <div class="item-header">
                <div class="user-info">
                  <div class="avatar">{{ trimmedUserName(item) }}</div>
                  <div class="user-details">
                    <span class="label-xs">{{
                      translator(
                        "Ubt-Measure-Detail-EffortBenefitAssessmentChangedBy"
                      )
                    }}</span>
                    <span class="user-name">{{ item.personFullName }}</span>
                  </div>
                </div>
                <div class="timestamp">
                  <i data-lucide="calendar" width="14" height="14"></i>
                  <span>{{ item.createdAt | date: "dd.MM.yyyy HH:mm" }}</span>
                </div>
              </div>

              <!-- Body: Metrics -->
              <div class="item-body">
                <div class="metrics-grid">
                  <!-- Metric 1 -->
                  <div class="metric-box">
                    <span class="metric-label">{{
                      translator(
                        "Ubt-Measure-Detail-EffortBenefitAssessmentMeasureEffect"
                      )
                    }}</span>
                    <span class="metric-value">{{
                      item.Impact | currency: "EUR" : "symbol" : "1.0-0"
                    }}</span>
                  </div>

                  <!-- Metric 2 -->
                  <div class="metric-box">
                    <span class="metric-label">{{
                      translator(
                        "Ubt-Measure-Detail-EffortBenefitAssessmentMeasureCosts"
                      )
                    }}</span>
                    <span class="metric-value">{{
                      item.Cost | currency: "EUR" : "symbol" : "1.0-0"
                    }}</span>
                  </div>

                  <!-- Progress Bar Metric -->
                  <div
                    class="metric-box"
                    style="grid-column: 1 / -1; max-width: 400px"
                  >
                    <div class="progress-container">
                      <div class="progress-header">
                        <span class="metric-label">
                          {{
                            translator(
                              "Ubt-Measure-Detail-EffortBenefitAssessmentMeasureTotalScore"
                            )
                          }}</span
                        >
                        <span class="score-text"
                          >{{ item.TotalScore }} / {{ maxScore }}</span
                        >
                      </div>
                      <abc-progress-bar
                        #progressBar
                        id="progress-bar-status"
                        width="100%"
                        [elementAttr]="{ 'aria-label': 'Progress Bar' }"
                        [min]="0"
                        [max]="maxScore"
                        [value]="item.TotalScore"
                        [showStatus]="false"
                      ></abc-progress-bar>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Footer: Comment -->
              <div class="item-footer">
                <div class="comment-box">
                  <div class="comment-icon">
                    <svg
                      fill="#000000"
                      viewBox="0 0 64 64"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      xml:space="preserve"
                      xmlns:serif="http://www.serif.com/"
                      style="
                        fill-rule: evenodd;
                        clip-rule: evenodd;
                        stroke-linejoin: round;
                        stroke-miterlimit: 2;
                      "
                      transform="matrix(-1, 0, 0, 1, 0, 0)"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        <rect
                          id="Icons"
                          x="-1216"
                          y="0"
                          width="1280"
                          height="800"
                          style="fill: none"
                        ></rect>
                        <g id="Icons1" serif:id="Icons">
                          <g id="Strike"></g>
                          <g id="H1"></g>
                          <g id="H2"></g>
                          <g id="H3"></g>
                          <g id="list-ul"></g>
                          <g id="hamburger-1"></g>
                          <g id="hamburger-2"></g>
                          <g id="list-ol"></g>
                          <g id="list-task"></g>
                          <path
                            id="quote-2"
                            d="M36.806,51.968l0,-8.026c2.537,-0.14 4.458,-0.604 5.761,-1.391c1.304,-0.786 2.22,-2.063 2.749,-3.829c0.528,-1.766 0.793,-4.293 0.793,-7.581l-9.303,0l0,-19.147l19.081,0l0,18.203c0,7.519 -1.612,13.028 -4.836,16.525c-3.225,3.497 -7.973,5.246 -14.245,5.246Zm-28.806,0l0,-8.026c2.537,-0.14 4.457,-0.586 5.761,-1.338c1.304,-0.752 2.247,-2.029 2.828,-3.83c0.581,-1.801 0.872,-4.345 0.872,-7.633l-9.461,0l0,-19.147l19.186,0l0,18.203c0,7.519 -1.603,13.028 -4.809,16.525c-3.207,3.497 -7.999,5.246 -14.377,5.246Z"
                            style="fill-rule: nonzero"
                          ></path>
                          <g id="trash"></g>
                          <g id="vertical-menu"></g>
                          <g id="horizontal-menu"></g>
                          <g id="sidebar-2"></g>
                          <g id="Pen"></g>
                          <g id="Pen1" serif:id="Pen"></g>
                          <g id="clock"></g>
                          <g id="external-link"></g>
                          <g id="hr"></g>
                          <g id="info"></g>
                          <g id="warning"></g>
                          <g id="plus-circle"></g>
                          <g id="minus-circle"></g>
                          <g id="vue"></g>
                          <g id="cog"></g>
                          <g id="logo"></g>
                          <g id="radio-check"></g>
                          <g id="eye-slash"></g>
                          <g id="eye"></g>
                          <g id="toggle-off"></g>
                          <g id="shredder"></g>
                          <g
                            id="spinner--loading--dots-"
                            serif:id="spinner [loading, dots]"
                          ></g>
                          <g id="react"></g>
                          <g id="check-selected"></g>
                          <g id="turn-off"></g>
                          <g id="code-block"></g>
                          <g id="user"></g>
                          <g id="coffee-bean"></g>
                          <g id="coffee-beans">
                            <g id="coffee-bean1" serif:id="coffee-bean"></g>
                          </g>
                          <g id="coffee-bean-filled"></g>
                          <g id="coffee-beans-filled">
                            <g id="coffee-bean2" serif:id="coffee-bean"></g>
                          </g>
                          <g id="clipboard"></g>
                          <g id="clipboard-paste"></g>
                          <g id="clipboard-copy"></g>
                          <g id="Layer1"></g>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div class="comment-content-wrapper">
                    <!-- Added 'line-clamp' class here -->
                    <p class="comment-text line-clamp">
                      {{ item.comment }}
                    </p>
                    <!-- Read More Button -->
                    <button
                      class="read-more-btn"
                      (click)="toggleComment(cardHistory)"
                    >
                      {{ translator("Ubt-Measure-Detail-ShowMore") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          } @empty {
            <p class="no-history">
              {{
                translator(
                  "Ubt-Measure-Detail-EffortBenefitAssessmentHistoryOfChanges"
                )
              }}
            </p>
          }
        </div>
      </dx-scroll-view>
    </div>
  </div>
</abc-popup>
